import React from "react";
import { createPortal } from "react-dom";

type CommonModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children?: React.ReactNode;
  size?: "md" | "lg" | "xl";
};

export default function CommonModal({
  isOpen,
  onClose,
  title = "Modal Title",
  children,
  size = "md",
}: CommonModalProps) {
  if (!isOpen) return null;

  const widthClass = {
    md: "max-w-md",
    lg: "max-w-4xl",
    xl: "max-w-6xl",
  }[size];

  return createPortal(
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto">
      <div
        className={`bg-background border-primaryAlt rounded-lg shadow w-full ${widthClass} relative`}>
        {/* Header */}
        <div className="flex border-primaryAlt items-center justify-between p-4 md:p-5 border-b rounded-t bg-primary/90 relative">
          <h3 className="text-xl font-semibold text-white">
            {title}
          </h3>
          <button onClick={onClose} type="button" className="text-white bg-transparent hover:text-secondary rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center" data-modal-hide="default-modal">
            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
        </div>

        {/* Body */}
        <div className="relative overflow-y-auto max-h-[75vh]">{children}</div>
      </div>
    </div>,
    document.body
  );
}